module.exports = __webpack_public_path__ + "img/3.54771f22.webp";